<nav>
  <ul>
    <li *ngFor="let item of menuItens" [routerLinkActive]="['active']">
      <bari-button size="medium" border="no" class="btn btn-font-gray" [routerLink]="[item.href]">
      {{item.name}}
      </bari-button>
    </li>
  </ul>
</nav>
